import React, { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { Container, Row, Col, Form, Table,InputGroup } from "react-bootstrap";
import { store } from "../../App";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { MdOutlineKeyboardReturn, MdOutlinePictureAsPdf } from "react-icons/md";
import "jspdf-autotable";
import { generatePdf, exportToExcel } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import Select from "react-select";
import MasterService from "../../Services/MasterService";
import {Button as MuiButton } from "@mui/material";
import { IoPersonAdd } from "react-icons/io5";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";

export default function HrmsDdoMaster() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); let username = localStorage.getItem("username"); const [enbTable, setEnbTable] = useState("ddo"); const [DDOCode, setDDOCode] = useState(""); const [OrgId, setOrgId] = useState(""); const [deptList, setDeptList] = useState([]); const [searchDDO, setSearchDDO] = useState(""); const [searchOrg, setSearchOrg] = useState(""); const [searchEmp, setSearchEmp] = useState(""); const [dataDDO, setDataDDO] = useState([]); const [dataOrg, setDataOrg] = useState([]); const [dataEmp, setDataEmp] = useState([]); const [DeptName, setDeptName] = useState("");

  const formik = useFormik({
    initialValues: {
      deptCode: "",
      ddocode:"",
    },
    onSubmit: (values) => {},
  });

  const DDOdata = async () => {
    try {
      const res = await MasterService.AllDeptartments();
      if (res.data) {
        const options = res.data.map((item) => ({ value: item.dept_id, label: `${item?.deptcode}-${item.dept_name}` }));
        setDeptList(options);
      }
    } catch (error) {
      console.error("Error fetching", error);
    }
  };

  useEffect(() => {
    DDOdata();
  }, []);

  const getData = async (value,type) => {
    if(type==="dept"){ formik.setFieldValue("deptCode", value || ""); formik.setFieldValue("ddocode","");
    }else if(type==="ddo"){ formik.setFieldValue("ddocode", value || ""); formik.setFieldValue("deptCode",""); }
    setDeptName("");
    if (!value) { setDataDDO([]); setDataOrg([]); setDataEmp([]); setEnbTable("ddo"); setSearchDDO(""); setSearchOrg(""); setSearchEmp(""); return; }
    store.dispatch({ type: "SHOW_SPINNER" });
    try {
      const res = type==="dept"? await KpiService.ddosData({ userId: username, deptCode: value.toString() }): await KpiService.getdddocodes({ userId: username, ddocode: value.toString() });
      if (res.data && res.data.status == "success") {
      setDeptName(res.data.newDDOs[0]?.dept_name);setDataDDO(res.data.newDDOs); setEnbTable("ddo"); setDDOCode(""); setOrgId(""); setSearchDDO(""); setSearchOrg(""); setSearchEmp("");
      } else {
        setDataDDO([]);
      }
    } catch (error) { console.error("Error fetching", error); } finally { store.dispatch({ type: "HIDE_SPINNER" }); }
  };

  const InsertDDO = async (ddoCode) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    try {
      const res = await KpiService.SaveNewddos({ userId: username, deptCode: formik.values.deptCode.toString(), ddoCode: ddoCode?.toString() });
      if (res.data && res.data.status == "success") {
        showAlertMessage(res.data.message, "success", () => { getData(formik.values.deptCode,"dept"); });
      } else {
        showAlertMessage(res.data.message, "waring");
        store.dispatch({ type: "HIDE_SPINNER" });
      }
    } catch (error) {
      store.dispatch({ type: "HIDE_SPINNER" });
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };

  const InsertOrg = async (orgId) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    try {
      const res = await KpiService.SaveNewOrgs({ userId: username, ddoCode: DDOCode, orgId: orgId?.toString() });
      if (res.data && res.data.status == "success") {
        showAlertMessage(res.data.message, "success", () => { OrganizaionData(DDOCode); });
      } else {
        showAlertMessage(res.data.message, "waring");
        store.dispatch({ type: "HIDE_SPINNER" });
      }
    } catch (error) { console.error("Error fetching", error); store.dispatch({ type: "HIDE_SPINNER" }); } finally { store.dispatch({ type: "HIDE_SPINNER" }); }
  };

  const InsertEmp = async (PosId) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    try {
      const res = await KpiService.SaveNewEmployee({ userId: username, orgId: OrgId, positionId: PosId });
      if (res.data && res.data.status == "success") {
        showAlertMessage(res.data.message, "success", () => { EmployeeData(OrgId); });
      } else {
        showAlertMessage(res.data.message, "waring");
        store.dispatch({ type: "HIDE_SPINNER" });
      }
    } catch (error) { console.error("Error fetching", error); store.dispatch({ type: "HIDE_SPINNER" }); } finally { store.dispatch({ type: "HIDE_SPINNER" }); }
  };

  const OrganizaionData = async (ddoCode) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    try {
      const res12 = await KpiService.fetchorgsData({ userId: username, ddoCode: ddoCode?.toString() });
      if (res12.data && res12.data.status == "success") {
        setDataOrg(res12.data.newORGS); setDDOCode(ddoCode.toString()); setEnbTable("org");
      } else {
        setDataOrg([]);
      }
    } catch (error) { console.error("Error fetching", error); } finally { store.dispatch({ type: "HIDE_SPINNER" }); }
  };

  const EmployeeData = async (OrgId) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    try {
      const response = await KpiService.fetchPositionList({ userId: username, orgId: OrgId?.toString() });
      if (response.data && response.data.status == "success") {
        setDataEmp(response.data.newPostionData); setOrgId(OrgId.toString()); setEnbTable("emp");
      } else {
        setDataEmp([]);
      }
    } catch (error) { console.error("Error fetching", error); } finally { store.dispatch({ type: "HIDE_SPINNER" }); }
  };

  const filteredDDOData =
    searchDDO.length > 0 && dataDDO?.length
      ? dataDDO.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchDDO.toLowerCase()); }) );
        })
      : dataDDO;

  const filteredOrgData =
    searchOrg.length > 0 && dataOrg?.length
      ? dataOrg.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchOrg.toLowerCase()); }) );
        })
      : dataOrg;

  const filteredEmpData =
    searchEmp.length > 0 && dataEmp?.length
      ? dataEmp.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchEmp.toLowerCase()); }) );
        })
      : dataEmp;

  return (
    <>
      <Menubar />

      <Container className="map-header1" fluid style={{ width: "97%" }}> <div className="sa-title"> <h2> HRMS DDO <span>Master</span> </h2> </div> </Container>

      <Container fluid style={{ width: "83%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container py-2 px-4">
            <Row className="align-items-center g-2">
              <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}> <div className="w-100"><label htmlFor="deptCode" className="form-label">Department Name<span className="text-danger">*</span></label><Select options={deptList} menuPortalTarget={document.body} value={deptList.find(option => option.value === formik.values.deptCode) || null} onChange={option => getData(option ? option.value : null,"dept")} placeholder="Select" isClearable classNamePrefix="react-select" /><ErrorMessage name="deptCode" component="div" className="text-danger" /></div> </Col>
              <Col xs="auto" className="d-flex justify-content-center align-items-center px-4 mt-auto mb-2" style={{ fontWeight: "bold" }}>(OR)</Col>
              <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}> <div className="w-100"> <Form.Group><Form.Label>DDO Code <span className="text-danger">*</span></Form.Label> <InputGroup> <Field type="text" name="ddocode" onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')} className={`form-control ${formik.touched.ddocode && formik.errors.ddocode ? "is-invalid" : ""}`} /> <MuiButton variant="contained" size="small" type="button" onClick={()=>{getData(formik.values.ddocode,"ddo")}} className="text-black" style={{ backgroundColor: "#ffc107"}}>Get</MuiButton> </InputGroup> </Form.Group> <ErrorMessage name="ddocode" component="div" className="text-danger" /></div> </Col>
            </Row>
            </div>
            {enbTable == "ddo" && (
              <>
        
                <Row style={{ marginTop: "2.5rem" }}>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2"> <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} > <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} type="text" placeholder="Search" value={searchDDO} onChange={(event) => setSearchDDO(event.target.value)} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: 1, border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} /> </div> </Col>
                  <Col className="mb-2"> <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "DDO list",9)} style={{ float: "right", marginLeft: "3px" }}> PDF <MdOutlinePictureAsPdf /> </button> <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "DDO List")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button> </Col>
                </Row>
                <div id="table-scroll" className="table-scroll table-wrap">
                  <Table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered">
                    <thead>
                          {DeptName&& <tr><th colSpan={9}>{DeptName}</th></tr>}
                       <tr className="text-center"> <th>Sl.No.</th> <th>DDO Code</th> <th>DDO Name</th> <th>District</th> <th>Status</th> </tr> </thead>

                    <tbody>
                      {filteredDDOData?.length === 0 || filteredDDOData?.length === undefined ? (
                        <tr>
                          <td className="text-center" colSpan="9">
                            <b style={{ color: "red" }}>Details Not Found</b>
                          </td>
                        </tr>
                      ) : (
                        filteredDDOData?.map((detail, i) => (
                          <tr key={i}>
                            <td className="text-center"> {i + 1} </td> <td className="text-center"> <button style={{ color: "#0047AB", cursor: "pointer",fontWeight:"bold" }} onClick={() => OrganizaionData(detail.ddocode)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); OrganizaionData(detail?.ddocode); } }} tabIndex={0} type="button" > {detail?.ddocode} </button> </td> <td className="text-left">{detail?.ddocode_description}</td> <td className="text-left">{detail?.district_name}</td>
                            <td className="text-center">
                              {detail.existsInLocalDb == true ? (
                                "Yes"
                              ) : (
                                <MuiButton type="button" onClick={() => { InsertDDO(detail?.ddocode); }} endIcon={<IoPersonAdd className="mb-1" style={{ fontSize: "15px" }} />} color="error" variant="contained" size="small" > Insert </MuiButton>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </>
            )}

            {enbTable == "org" && (
              <>
                <Row style={{ marginTop: "2.5rem" }}>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2">
                    <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} > <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search" value={searchOrg} onChange={(event) => setSearchOrg(event.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: 1, border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} /> </div>
                  </Col>
                  <Col className="mb-2 d-flex justify-content-end gap-2"> <button className="btn btn-danger btn-sm pdf-btn" onClick={() => generatePdf("#my-table", "Organizaion List",9)}> PDF <MdOutlinePictureAsPdf /> </button> <button size="sm" className="btn excel-btn" style={{ color: "#ffffff" }} onClick={() => exportToExcel("my-table", "Organizaion List")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button> <button size="sm" className="btn back-btn" onClick={() => { setEnbTable("ddo"); setDDOCode(""); }} > <MdOutlineKeyboardReturn style={{ fontSize: "18px" }} /> Back </button> </Col>
                </Row>

                <div id="table-scroll" className="table-scroll table-wrap">
                  <Table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered">
                    <thead>
                      {DeptName&& <tr><th  colSpan={9}>{DeptName}</th></tr>}
                      <tr className="text-center"> <th >Sl.No.</th> <th >Organizaion Id</th> <th >Organizaion Name</th> <th >Status</th> </tr> </thead>

                    <tbody>
                      {filteredOrgData?.length === 0 || filteredOrgData?.length === undefined ? (
                        <tr>
                          <td className="text-center" colSpan="9">
                            <b style={{ color: "red" }}>Details Not Found</b>
                          </td>
                        </tr>
                      ) : (
                        filteredOrgData?.map((detail, i) => (
                          <tr key={i}>
                            <td className="text-center"> {i + 1} </td>
                            <td className="text-center"> <button style={{ color: "#0047AB", cursor: "pointer",fontWeight:"bold" }} onClick={() => EmployeeData(detail?.org_id)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); EmployeeData(detail?.org_id); } }} tabIndex={0} role="button" > {detail.org_id} </button> </td> <td className="text-left">{detail.org_name}</td>
                            <td className="text-center">
                              {detail.existsInLocalDb == true ? (
                                "Yes"
                              ) : (
                                <MuiButton type="button" onClick={() => { InsertOrg(detail?.org_id); }} endIcon={<IoPersonAdd className="mb-1" style={{ fontSize: "15px" }} />} color="error" variant="contained" size="small" > Insert </MuiButton>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </>
            )}

            {enbTable == "emp" && (
              <>
                <Row style={{ marginTop: "2.5rem" }}>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-2"> <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} > <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchEmp} onChange={(event) => setSearchEmp(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
                  <Col className="mb-2 d-flex justify-content-end gap-2"> <button className="btn btn-danger btn-sm pdf-btn" onClick={() => generatePdf("#my-table", "Employee List",9)}> PDF <MdOutlinePictureAsPdf /> </button> <button variant="success" size="sm" className="btn excel-btn" style={{ color: "#ffffff" }} onClick={() => exportToExcel("my-table", "Employee List")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button> <button size="sm" className="btn back-btn" onClick={() => { setEnbTable("org"); setOrgId(""); }} > <MdOutlineKeyboardReturn style={{ fontSize: "18px" }} /> Back </button> </Col>
                </Row>

                <div id="table-scroll" className="table-scroll table-wrap">
                  <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered">
                    <thead>
                          {DeptName&& <tr><th colSpan={9}>{DeptName}</th></tr>}
                       <tr className="text-center"> <th>Sl.No.</th> <th>Position Id</th> <th>Position</th> <th>Occupied Category</th> <th>CFMS Id</th> <th>Status</th> </tr> </thead>

                    <tbody>
                      {filteredEmpData?.length === 0 || filteredEmpData?.length === undefined ? (
                        <tr> <td className="text-center" colSpan="9"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                      ) : (
                        filteredEmpData?.map((detail, i) => (
                          <tr key={i}>
                            <td className="text-center"> {i + 1} </td> <td className="text-center">{detail.position_id}</td> <td className="text-left">{detail.position_name}</td> <td className="text-center">{detail.occupied_category}</td> <td className="text-center">{detail.cfmsid == "0" ? "-" : detail.cfmsid}</td>
                            <td className="text-center">
                              {detail.existsInLocalDb == true ? (
                                "Yes"
                              ) : (
                                <MuiButton type="button" onClick={() => { InsertEmp(detail?.position_id); }} endIcon={<IoPersonAdd className="mb-1" style={{ fontSize: "15px" }} />} color="error" variant="contained" size="small" > Insert </MuiButton>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </Form>
        </FormikProvider>
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
